<template>
    <div>
        <button class="dropdown dropdown-header" v-on:click="onDropdownClicked()">
            <div class="dropdown-name">
                {{initialValue}}
            </div>
            <img class="option-header-arrow" :src="getImage('fixtures-dropdown-icon')">
        </button>
        <div class="collapse dropdown-body">
            <button v-for="(dropdownOption, index) in dropdownConfig.dropDownOptions" :key="index" class="dropdown dropdown-option text" v-on:click="onOptionClicked(index)">
                {{dropdownOption.name}}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Dropdown',
        data: function() {
            return {
                initialValue: 'Select Option'
            }
        },
        props: {
            dropdownConfig: Object
        },
        methods: {
            getImage(imagePath) {
                return require('../assets/images/' + imagePath + '.svg');
            },
            onDropdownClicked() {
                document.querySelector(`.dropdown-body`).classList.toggle('collapse');
                document.querySelectorAll(`#${this.accordionId}`).forEach((element) =>
                    element.classList.toggle('dropdown-focus')
                );
            },
            onOptionClicked(index) {
                this.dropdownConfig.dropDownOptions[index].onClickCallback();
                document.querySelector('.dropdown-name').innerHTML = `${this.dropdownConfig.dropDownOptions[index].name}`;
            }
        },
        mounted: function () {
            this.initialValue = this.dropdownConfig.placeHolder ? this.dropdownConfig.placeHolder : this.dropdownConfig.dropDownOptions[0].name;
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .dropdown-body  {
        position: absolute;
        width: 100%;
        z-index: 10;
    }

    .dropdown-header {
        position: relative;
        font-size: 1.8rem;
        font-weight: bolder;
        background-color: #FFFFFF;
        color: #000000;
        border: solid 1px #000000;
    }

    .dropdown-option {
        font-size: 1.3rem;
        background-color: #000000;
        border: solid 1px #FFFFFF;
        padding: 0.6rem 0 0.6rem 0;
        margin-bottom: 0.3rem;
    }

    .dropdown {
        opacity: 0.9;
        width: 100%;
        text-align: center;
        border-radius: 5px;
        box-shadow: 0 10px 12px -4px black;
    }

    .dropdown:hover {
        cursor: pointer;
    }

    .dropdown:focus {
        outline:0;
    }

    .dropdown-focus {
        background-color: #000000;
    }

    .dropdown-name {
        font-size: 1.3rem;
        position: absolute;
        left: 50%;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .option-img {
        width: 45px;
        float: left;
    }

    .dropdown-option:hover {
        opacity: 1 !important;
        background-color: #000000 !important;
    }

    .option-header-arrow {
        width: 45px;
        float: right;
    }

    button:hover {
        background-color: #F0F0F0;
    }
</style>
